"use strict";

/* eslint prefer-template:0 */
module.exports = function getSubdomain(domain) {
  if (!domain) {
    return '';
  }

  var subDomain = domain.split('.');

  if (subDomain.length <= 2) {
    subDomain = domain;
  } else {
    var beforeLastPart = subDomain[subDomain.length - 2];
    var topLevelDomains = {
      com: true,
      org: true,
      net: true,
      edu: true,
      gov: true,
      mil: true,
      info: true,
      co: true,
      ac: true
    };

    if (topLevelDomains[beforeLastPart]) {
      subDomain = subDomain[subDomain.length - 3] + '.' + subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
    } else {
      subDomain = subDomain[subDomain.length - 2] + '.' + subDomain[subDomain.length - 1];
    }
  }

  return subDomain;
};
//# sourceMappingURL=getSubdomain.js.map